var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRatingMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 emoji \"white medium star\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00647 1.15267L9.68906 4.99037C9.81782 5.28414 10.0966 5.4854 10.4166 5.51415L14.5156 5.88167C14.9793 5.94917 15.1644 6.51795 14.8281 6.84547L11.7404 9.43936C11.4904 9.64937 11.3767 9.97939 11.4454 10.2982L12.343 14.4996C12.4217 14.9609 11.9379 15.3134 11.5229 15.0947L7.94522 12.9995C7.67021 12.8383 7.33019 12.8383 7.05517 12.9995L3.47748 15.0934C3.06371 15.3109 2.57869 14.9597 2.65744 14.4984L3.55499 10.2969C3.62249 9.97814 3.50998 9.64812 3.25997 9.43811L0.171057 6.84672C-0.163961 6.52045 0.0210492 5.95042 0.483574 5.88292L4.58254 5.5154C4.90256 5.48665 5.18132 5.28539 5.31008 4.99162L6.99267 1.15392C7.20143 0.733896 7.79896 0.733896 8.00647 1.15267Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.88357 5.22038L7.59855 2.39273C7.5873 2.23522 7.5548 1.96521 7.80732 1.96521C8.00733 1.96521 8.11608 2.38148 8.11608 2.38148L8.97113 4.6516C9.29364 5.5154 9.16114 5.81167 8.84987 5.98667C8.49235 6.18669 7.96482 6.03043 7.88357 5.22038Z",
    fill: "#FFFF8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4101 9.18811L13.8627 7.27426C13.984 7.173 14.2027 7.01175 14.0277 6.82799C13.889 6.68298 13.514 6.89174 13.514 6.89174L11.3676 7.73053C10.7276 7.95179 10.3025 8.27931 10.265 8.69183C10.2163 9.24186 10.7101 9.66564 11.4101 9.18811Z",
    fill: "#F4B400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRatingMini);
export default __webpack_public_path__ + "static/media/starRatingMini.2d5936287d9881c6e01f38337e8127bb.svg";
export { ForwardRef as ReactComponent };